import type { EnrolPupilMutation$data } from "pianofunclub-shared/relay/graphql/accounts/__generated__/EnrolPupilMutation.graphql";

export const getEnrolErrorToastText = (response: EnrolPupilMutation$data) => {
  const errorCode = response?.enrolPupil?.errors?.code;
  const errorMessage = response?.enrolPupil?.errors?.message;

  let title = "Failed to enrol pupil";
  let description = "Please get in touch with one of the team";

  if (errorCode === "enrolment_no_offer_found") {
    title = "No offer found";
    description = "Please make an offer for a lesson slot first before enrolling.";
  } else if (errorCode === "enrolment_lesson_slot_no_longer_available") {
    title = "Lesson slot unavailable";
    description = "The lesson slot from the offer has been assigned to another pupil.";
  } else if (errorMessage) {
    description = errorMessage;
  }

  return { description, title };
};
